<template>
  <el-input-number v-model="mValue" size="mini"></el-input-number>
</template>
<script>
import { InputNumber } from 'element-ui'

export default {
  components: {
    "ElInputNumber": InputNumber,
  },
  props: ['value'],
  computed: {
    mValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
